exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".unit2b #slots .fixed-answer{line-height:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/2/2b/diagram2/diagram2.scss
// module id = 1006
// module chunks = 0